export const getCategoryLink = (productCategory: string | undefined) => {
  if (productCategory === 'kitchen-tapware' || productCategory === 'laundry-tapware')
    return '/kitchen-laundry/tapware/';
  if (productCategory === 'care-tapware') return '/independent-living/tapware/';
  if (
    productCategory === 'basin-mixers' ||
    productCategory === 'outlets-spouts' ||
    productCategory === 'three-piece-tapware' ||
    productCategory === 'tapware-assemblies' ||
    productCategory === 'tapware-spare-parts' ||
    productCategory === 'bath-shower-mixers'
  )
    return '/bathroom/tapware/';
  if (
    productCategory === 'care-toilets' ||
    productCategory === 'cisterns' ||
    productCategory === 'toilet-pans' ||
    productCategory === 'toilet-seats'
  )
    return '/independent-living/toilets/';
  if (
    productCategory === 'care-toilets' ||
    productCategory === 'cisterns' ||
    productCategory === 'toilet-pans' ||
    productCategory === 'toilet-seats'
  )
    return '/independent-living/toilets/';
  if (
    productCategory === 'urinals' ||
    productCategory === 'bidet-suites' ||
    productCategory === 'toilet-suites' ||
    productCategory === 'toilet-spare-parts' ||
    productCategory === 'buttons-accessories'
  )
    return '/bathroom/toilet-suites/';
  if (
    productCategory === 'wall-mounted-basins' ||
    productCategory === 'inset-basins' ||
    productCategory === 'shroud-pedestal-basins' ||
    productCategory === 'above-counter-basins' ||
    productCategory === 'under-counter-basins' ||
    productCategory === 'vanity-basins' ||
    productCategory === 'basin-spare-parts' ||
    productCategory === 'semi-recessed-basins'
  )
    return '/bathroom/basins/';
  if (productCategory === 'care-basins') return '/independent-living/basins/';
  if (productCategory === 'baths-l2' || productCategory === 'spa-baths' || productCategory === 'bath-spare-parts')
    return '/bathroom/baths/';
  if (productCategory === 'care-showers' || productCategory === 'shower-heads-outlets')
    return '/independent-living/showers/';
  if (
    productCategory === 'shower-systems' ||
    productCategory === 'shower-systems' ||
    productCategory === 'shower-spare-parts'
  )
    return '/bathroom/showers/';
  if (productCategory === 'care-accessories') return '/independent-living/bathroom-accessories/';
  if (
    productCategory === 'bathroom-holders' ||
    productCategory === 'shelves-cabinets' ||
    productCategory === 'soap-accessories' ||
    productCategory === 'toilet-roll-accessories' ||
    productCategory === 'towel-accessories'
  )
    return '/bathroom/bathroom-accessories/';
  if (
    productCategory === 'kitchen-accessories' ||
    productCategory === 'sinks' ||
    productCategory === 'kitchen-laundry-spare-parts' ||
    productCategory === 'care-sinks'
  )
    return '/kitchen-laundry/kitchen-sinks-accessories/';
  if (productCategory === 'tubs' || productCategory === 'tubs-cabinets') return '/kitchen-laundry/laundry-tubs/';

  return '/bathroom/';
};
